import {
  SkillDocumentResponse,
  SkillTestQuestion,
  TheoryLevelRequest,
  TheoryLevelResponse,
} from '../../../models/skill-learning.model';

export const THEORY_FIXED_QUESTIONS_COUNT = 20;
export const THEORY_FIXED_TIME_LIMIT_MINUTES = 10;
export const THEORY_FIXED_PASSING_PERCENTAGE = 95;
export const THEORY_MIN_DESCRIPTION_LENGTH = 50;
export const THEORY_MIN_TEST_BANK_QUESTIONS = 50;
export const THEORY_MAX_TEST_BANK_QUESTIONS = 200;
export const THEORY_ANSWER_OPTIONS_COUNT = 3;
export const THEORY_DIRECTIONS_PROMPT_COPIED_KEY = 'SKILL_LEARNING_ADMIN_THEORY_PROMPT_COPIED';
export const THEORY_DESCRIPTION_CONTROL = 'description';

export abstract class TheoryLevelInput implements TheoryLevelResponse {
  abstract description: string;
  abstract topics: string[];
  abstract documentFileId: string | null;
  abstract document: SkillDocumentResponse | null;
  abstract questionsCount: number;
  abstract timeLimitMinutes: number;
  abstract passingPercentage: number;
  abstract testQuestions?: SkillTestQuestion[];
}

export interface TheoryLevelSavePayload {
  levelNumber: number;
  request: TheoryLevelRequest;
  documentFile: File | null;
}

export interface TheoryTestGenerationPayload {
  levelNumber: number;
  description: string;
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/components/admin/theory-level-editor/theory-level-editor.option.ts